module.exports = __webpack_public_path__ + "static/media/image-card-2.ab01a5a6.png";